import React, { useEffect, useState } from 'react';

const VESTIGA_CSS = `
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --teal: #2dd4aa;
  --teal-dim: rgba(45,212,170,0.12);
  --teal-mid: rgba(45,212,170,0.25);
  --dark: #0d1f1d;
  --dark2: #142520;
  --dark3: #1a2f2b;
  --white: #ffffff;
  --off: #f5f7f6;
  --gray1: #374151;
  --gray2: #6b7280;
  --gray3: #d1d5db;
  --gray4: #f3f4f6;
  --amber: #EF9F27;
  --red: #E24B4A;
  --green: #0F6E56;
}

.vestiga-page { font-family: 'Inter', sans-serif; background: var(--white); color: var(--gray1); line-height: 1.6; -webkit-font-smoothing: antialiased; }
.vestiga-page html { scroll-behavior: smooth; }

/* NAV */
.v-nav {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 200;
  background: rgba(13,31,29,0.96);
  backdrop-filter: blur(12px);
  border-bottom: 0.5px solid rgba(255,255,255,0.06);
  padding: 0 5%;
  height: 58px;
  display: flex;
  align-items: center;
  gap: 32px;
}
.v-nav-logo { font-size: 17px; font-weight: 700; color: var(--teal); letter-spacing: 0.06em; text-transform: uppercase; flex-shrink: 0; }
.v-nav-links { display: flex; gap: 28px; flex: 1; list-style: none; }
.v-nav-links a { font-size: 13px; color: rgba(255,255,255,0.55); text-decoration: none; transition: color 0.2s; }
.v-nav-links a:hover { color: rgba(255,255,255,0.9); }
.v-nav-cta { padding: 8px 18px; background: var(--teal); color: var(--dark); font-size: 12px; font-weight: 600; border-radius: 6px; text-decoration: none; white-space: nowrap; transition: opacity 0.2s; }
.v-nav-cta:hover { opacity: 0.88; }

/* HERO */
#v-hero { min-height: 100vh; background: var(--dark); display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 120px 5% 80px; position: relative; overflow: hidden; }
.v-hero-glow { position: absolute; width: 700px; height: 700px; background: radial-gradient(circle, rgba(45,212,170,0.08) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -60%); pointer-events: none; }
.v-hero-eyebrow { display: inline-flex; align-items: center; gap: 8px; font-size: 11px; font-weight: 600; color: var(--teal); letter-spacing: 0.12em; text-transform: uppercase; background: var(--teal-dim); border: 0.5px solid rgba(45,212,170,0.25); border-radius: 20px; padding: 5px 14px; margin-bottom: 32px; }
.v-hero-eyebrow-dot { width: 6px; height: 6px; background: var(--teal); border-radius: 50%; animation: v-pulse 2s infinite; }
@keyframes v-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
.v-hero-headline { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(40px, 6vw, 72px); font-weight: 700; color: var(--white); line-height: 1.1; max-width: 820px; margin-bottom: 10px; }
.v-hero-headline em { font-style: italic; color: var(--teal); }
.v-hero-sub { font-size: clamp(16px, 2vw, 20px); color: rgba(255,255,255,0.55); max-width: 560px; margin: 18px auto 42px; line-height: 1.65; }
.v-hero-actions { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; margin-bottom: 70px; }

.v-btn-primary { padding: 14px 32px; background: var(--teal); color: var(--dark); font-size: 14px; font-weight: 700; border-radius: 8px; text-decoration: none; border: none; cursor: pointer; font-family: inherit; transition: opacity 0.2s, transform 0.15s; }
.v-btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }
.v-btn-ghost { padding: 14px 32px; background: transparent; color: rgba(255,255,255,0.7); font-size: 14px; font-weight: 500; border-radius: 8px; text-decoration: none; border: 0.5px solid rgba(255,255,255,0.15); cursor: pointer; font-family: inherit; transition: background 0.2s, color 0.2s; }
.v-btn-ghost:hover { background: rgba(255,255,255,0.06); color: var(--white); }

/* MOCKUP */
.v-hero-mockup { width: 100%; max-width: 900px; background: #0a1a18; border: 0.5px solid rgba(45,212,170,0.2); border-radius: 14px; overflow: hidden; box-shadow: 0 40px 120px rgba(0,0,0,0.6), 0 0 0 0.5px rgba(45,212,170,0.1); }
.v-mockup-bar { background: #061210; padding: 10px 16px; display: flex; align-items: center; gap: 8px; border-bottom: 0.5px solid rgba(255,255,255,0.06); }
.v-mockup-dots { display: flex; gap: 6px; }
.v-mockup-dot { width: 10px; height: 10px; border-radius: 50%; }
.v-mockup-dot:nth-child(1) { background: #ff5f57; }
.v-mockup-dot:nth-child(2) { background: #febc2e; }
.v-mockup-dot:nth-child(3) { background: #28c840; }
.v-mockup-url { flex: 1; text-align: center; font-size: 11px; color: rgba(255,255,255,0.2); font-family: monospace; }
.v-mockup-body { display: grid; grid-template-columns: 180px 1fr; min-height: 380px; }
.v-mockup-sidebar { background: #0d1f1d; padding: 16px 10px; border-right: 0.5px solid rgba(255,255,255,0.06); }
.v-ms-logo { font-size: 12px; font-weight: 700; color: var(--teal); letter-spacing: 0.08em; text-transform: uppercase; padding: 0 6px 12px; border-bottom: 0.5px solid rgba(255,255,255,0.08); margin-bottom: 12px; }
.v-ms-section { font-size: 9px; color: rgba(255,255,255,0.25); letter-spacing: 0.1em; text-transform: uppercase; padding: 10px 6px 4px; }
.v-ms-item { display: flex; align-items: center; gap: 8px; padding: 6px 8px; border-radius: 5px; font-size: 11px; color: rgba(255,255,255,0.55); margin: 1px 0; cursor: default; }
.v-ms-item.active { background: rgba(45,212,170,0.15); color: var(--teal); }
.v-ms-item-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.v-ms-badge { margin-left: auto; font-size: 9px; padding: 1px 5px; border-radius: 8px; font-weight: 600; }
.v-ms-badge.teal { background: rgba(45,212,170,0.15); color: var(--teal); }
.v-ms-badge.alert { background: rgba(216,90,48,0.15); color: #D85A30; }
.v-mockup-main { background: #0f2320; padding: 16px; display: flex; flex-direction: column; gap: 12px; }
.v-m-topbar { display: flex; align-items: center; gap: 10px; padding-bottom: 12px; border-bottom: 0.5px solid rgba(255,255,255,0.06); }
.v-m-title { font-size: 13px; font-weight: 600; color: var(--white); flex: 1; }
.v-m-search { font-size: 10px; color: rgba(255,255,255,0.3); background: rgba(255,255,255,0.05); border-radius: 5px; padding: 5px 10px; }
.v-m-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.v-m-stat { background: rgba(255,255,255,0.04); border: 0.5px solid rgba(255,255,255,0.07); border-radius: 7px; padding: 10px 12px; }
.v-m-stat-label { font-size: 9px; color: rgba(255,255,255,0.35); margin-bottom: 4px; }
.v-m-stat-val { font-size: 20px; font-weight: 700; color: var(--white); line-height: 1; }
.v-m-stat-val.accent { color: var(--teal); }
.v-m-stat-sub { font-size: 9px; color: rgba(255,255,255,0.2); margin-top: 2px; }
.v-m-panels { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.v-m-panel { background: rgba(255,255,255,0.03); border: 0.5px solid rgba(255,255,255,0.07); border-radius: 7px; overflow: hidden; }
.v-m-panel-hdr { display: flex; align-items: center; padding: 8px 10px; border-bottom: 0.5px solid rgba(255,255,255,0.06); font-size: 10px; font-weight: 600; color: rgba(255,255,255,0.7); gap: 6px; }
.v-m-panel-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--teal); }
.v-m-queue-item { display: flex; align-items: center; gap: 8px; padding: 7px 10px; border-bottom: 0.5px solid rgba(255,255,255,0.04); }
.v-m-queue-item:last-child { border-bottom: none; }
.v-m-score { font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 8px; }
.v-m-score.strong { background: rgba(15,110,86,0.25); color: #2dd4aa; }
.v-m-score.probable { background: rgba(133,79,11,0.25); color: #EF9F27; }
.v-m-score.weak { background: rgba(163,45,45,0.25); color: #E24B4A; }
.v-m-qname { font-size: 10px; font-weight: 500; color: rgba(255,255,255,0.8); flex: 1; }
.v-m-qmeta { font-size: 9px; color: rgba(255,255,255,0.3); }
.v-m-act-item { display: flex; align-items: flex-start; gap: 7px; padding: 7px 10px; border-bottom: 0.5px solid rgba(255,255,255,0.04); }
.v-m-act-item:last-child { border-bottom: none; }
.v-m-act-dot { width: 6px; height: 6px; border-radius: 50%; margin-top: 4px; flex-shrink: 0; }
.v-m-act-text { font-size: 10px; color: rgba(255,255,255,0.6); line-height: 1.4; flex: 1; }
.v-m-act-time { font-size: 9px; color: rgba(255,255,255,0.25); margin-top: 2px; }

/* SECTION */
.v-section { padding: 96px 5%; }
.v-section-eyebrow { font-size: 11px; font-weight: 600; color: var(--teal); letter-spacing: 0.12em; text-transform: uppercase; margin-bottom: 14px; }
.v-section-headline { font-family: 'Playfair Display', serif; font-size: clamp(28px, 4vw, 44px); font-weight: 700; color: var(--dark); line-height: 1.15; max-width: 680px; margin-bottom: 16px; }
.v-section-sub { font-size: 16px; color: var(--gray2); max-width: 560px; line-height: 1.7; margin-bottom: 56px; }

/* PROBLEM */
#v-problem { background: var(--off); }
.v-problem-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.v-problem-card { background: var(--white); border: 0.5px solid var(--gray3); border-radius: 10px; padding: 28px 24px; position: relative; overflow: hidden; }
.v-problem-card::before { content: ''; position: absolute; top: 0; left: 0; width: 3px; height: 100%; background: var(--red); }
.v-problem-num { font-size: 11px; font-weight: 700; color: var(--red); letter-spacing: 0.1em; margin-bottom: 12px; opacity: 0.6; }
.v-problem-title { font-size: 15px; font-weight: 600; color: var(--dark); margin-bottom: 8px; }
.v-problem-body { font-size: 13px; color: var(--gray2); line-height: 1.6; }

/* SOLUTION */
#v-solution { background: var(--white); }
.v-solution-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: start; }
.v-feature-list { display: flex; flex-direction: column; gap: 0; }
.v-feature-item { display: flex; gap: 16px; padding: 20px 0; border-bottom: 0.5px solid var(--gray4); cursor: pointer; transition: all 0.2s; }
.v-feature-item:first-child { padding-top: 0; }
.v-feature-item:last-child { border-bottom: none; }
.v-feature-icon { width: 40px; height: 40px; border-radius: 8px; background: var(--teal-dim); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 18px; }
.v-feature-item.active .v-feature-icon { background: var(--dark); }
.v-feature-title { font-size: 14px; font-weight: 600; color: var(--dark); margin-bottom: 4px; }
.v-feature-desc { font-size: 13px; color: var(--gray2); line-height: 1.5; }
.v-feature-showcase { position: sticky; top: 80px; background: var(--dark); border-radius: 14px; overflow: hidden; border: 0.5px solid rgba(45,212,170,0.15); box-shadow: 0 20px 60px rgba(0,0,0,0.15); min-height: 340px; display: flex; flex-direction: column; }
.v-fs-header { padding: 14px 18px; border-bottom: 0.5px solid rgba(255,255,255,0.07); font-size: 12px; font-weight: 600; color: var(--teal); background: rgba(45,212,170,0.05); }
.v-fs-body { padding: 20px 18px; flex: 1; }
.v-fs-record { display: flex; align-items: center; gap: 12px; padding: 10px 14px; background: rgba(255,255,255,0.04); border: 0.5px solid rgba(255,255,255,0.07); border-radius: 8px; margin-bottom: 10px; }
.v-fs-avatar { width: 32px; height: 32px; border-radius: 50%; background: var(--dark3); border: 1.5px solid var(--teal); display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 700; color: var(--teal); flex-shrink: 0; }
.v-fs-name { font-size: 12px; font-weight: 600; color: var(--white); }
.v-fs-meta { font-size: 10px; color: rgba(255,255,255,0.4); margin-top: 2px; }
.v-fs-score-ring { width: 48px; height: 48px; margin-left: auto; flex-shrink: 0; }
.v-fs-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 12px; }
.v-fs-field { background: rgba(255,255,255,0.03); border: 0.5px solid rgba(255,255,255,0.07); border-radius: 6px; padding: 8px 10px; }
.v-fs-field-label { font-size: 9px; color: rgba(255,255,255,0.3); letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 3px; }
.v-fs-field-val { font-size: 11px; color: rgba(255,255,255,0.8); font-weight: 500; }
.v-fs-pill { display: inline-block; font-size: 10px; font-weight: 600; padding: 2px 9px; border-radius: 10px; margin-right: 5px; }
.v-fs-pill.teal { background: rgba(45,212,170,0.15); color: var(--teal); }
.v-fs-pill.amber { background: rgba(239,159,39,0.15); color: var(--amber); }
.v-fs-pill.red { background: rgba(226,75,74,0.15); color: var(--red); }
.v-fs-match-row { display: flex; align-items: center; gap: 10px; padding: 8px 10px; background: rgba(45,212,170,0.06); border: 0.5px solid rgba(45,212,170,0.2); border-radius: 6px; margin-bottom: 8px; }
.v-fs-match-score { font-size: 13px; font-weight: 700; color: var(--teal); flex-shrink: 0; }
.v-fs-match-name { font-size: 11px; font-weight: 500; color: rgba(255,255,255,0.8); flex: 1; }
.v-fs-match-src { font-size: 10px; color: rgba(255,255,255,0.3); }

/* SEGMENTS */
#v-segments { background: var(--dark); }
#v-segments .v-section-headline { color: var(--white); }
#v-segments .v-section-sub { color: rgba(255,255,255,0.5); }
#v-segments .v-section-eyebrow { color: var(--teal); }
.v-segments-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.v-segment-card { background: rgba(255,255,255,0.04); border: 0.5px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 24px 22px; transition: border-color 0.2s, background 0.2s; }
.v-segment-card:hover { background: rgba(45,212,170,0.06); border-color: rgba(45,212,170,0.25); }
.v-segment-icon { font-size: 28px; margin-bottom: 14px; }
.v-segment-title { font-size: 14px; font-weight: 600; color: var(--white); margin-bottom: 6px; }
.v-segment-body { font-size: 12px; color: rgba(255,255,255,0.45); line-height: 1.6; }
.v-segment-count { font-size: 11px; color: var(--teal); font-weight: 600; margin-top: 12px; }

/* ORIGIN */
#v-origin { background: var(--off); }
.v-origin-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
.v-origin-quote { font-family: 'Playfair Display', serif; font-size: clamp(18px, 2.5vw, 26px); font-style: italic; color: var(--dark); line-height: 1.5; margin-bottom: 24px; position: relative; padding-left: 20px; border-left: 3px solid var(--teal); }
.v-origin-body { font-size: 15px; color: var(--gray2); line-height: 1.75; margin-bottom: 18px; }
.v-origin-stat-row { display: flex; gap: 32px; margin-top: 32px; }
.v-origin-stat-val { font-size: 32px; font-weight: 700; color: var(--dark); line-height: 1; }
.v-origin-stat-label { font-size: 12px; color: var(--gray2); margin-top: 4px; }
.v-origin-visual { background: var(--dark); border-radius: 14px; padding: 28px; border: 0.5px solid rgba(45,212,170,0.15); }
.v-ov-title { font-size: 12px; color: var(--teal); font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 20px; }
.v-ov-row { display: flex; align-items: center; gap: 14px; padding: 12px 0; border-bottom: 0.5px solid rgba(255,255,255,0.06); }
.v-ov-row:last-child { border-bottom: none; }
.v-ov-num { width: 28px; height: 28px; border-radius: 50%; background: var(--teal-dim); color: var(--teal); font-size: 11px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.v-ov-label { font-size: 12px; color: rgba(255,255,255,0.75); line-height: 1.4; flex: 1; }
.v-ov-val { font-size: 13px; font-weight: 700; color: var(--teal); white-space: nowrap; }

/* PRICING */
#v-pricing { background: var(--white); }
.v-pricing-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; max-width: 1000px; margin: 0 auto; }
.v-pricing-card { border: 0.5px solid var(--gray3); border-radius: 12px; overflow: hidden; position: relative; transition: box-shadow 0.2s; }
.v-pricing-card:hover { box-shadow: 0 8px 32px rgba(0,0,0,0.1); }
.v-pricing-card.featured { border-color: var(--teal); box-shadow: 0 0 0 1px var(--teal); }
.v-pricing-badge { background: var(--teal); color: var(--dark); font-size: 10px; font-weight: 700; text-align: center; padding: 5px; letter-spacing: 0.1em; text-transform: uppercase; }
.v-pricing-header { background: var(--dark); padding: 24px; }
.v-pricing-header.light { background: var(--off); }
.v-pricing-name { font-size: 16px; font-weight: 700; color: var(--white); margin-bottom: 4px; }
.v-pricing-header.light .v-pricing-name { color: var(--dark); }
.v-pricing-price { font-size: 36px; font-weight: 700; color: var(--teal); line-height: 1; margin: 14px 0 4px; }
.v-pricing-header.light .v-pricing-price { color: var(--dark); }
.v-pricing-period { font-size: 13px; color: rgba(255,255,255,0.4); }
.v-pricing-header.light .v-pricing-period { color: var(--gray2); }
.v-pricing-desc { font-size: 12px; color: rgba(255,255,255,0.5); margin-top: 8px; line-height: 1.5; }
.v-pricing-header.light .v-pricing-desc { color: var(--gray2); }
.v-pricing-features { padding: 20px 24px; list-style: none; display: flex; flex-direction: column; gap: 10px; }
.v-pricing-features li { display: flex; align-items: flex-start; gap: 9px; font-size: 13px; color: var(--gray1); }
.v-pricing-check { width: 16px; height: 16px; border-radius: 50%; background: rgba(45,212,170,0.15); color: var(--teal); font-size: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 2px; font-weight: 700; }
.v-pricing-footer { padding: 0 24px 24px; }
.v-pricing-cta { display: block; text-align: center; padding: 11px; border-radius: 7px; font-size: 13px; font-weight: 600; text-decoration: none; transition: all 0.2s; cursor: pointer; font-family: inherit; border: none; }
.v-pricing-cta.dark { background: var(--dark); color: var(--teal); }
.v-pricing-cta.dark:hover { background: var(--dark2); }
.v-pricing-cta.teal { background: var(--teal); color: var(--dark); }
.v-pricing-cta.teal:hover { opacity: 0.88; }
.v-pricing-cta.outline { border: 0.5px solid var(--gray3); color: var(--gray1); background: transparent; }
.v-pricing-cta.outline:hover { background: var(--off); }

/* CTA */
#v-cta { background: var(--dark); text-align: center; padding: 100px 5%; position: relative; overflow: hidden; }
.v-cta-glow { position: absolute; width: 500px; height: 500px; background: radial-gradient(circle, rgba(45,212,170,0.1) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: none; }
#v-cta .v-section-headline { color: var(--white); max-width: 600px; margin: 14px auto 16px; }
#v-cta .v-section-eyebrow { color: var(--teal); }
.v-cta-sub { font-size: 16px; color: rgba(255,255,255,0.5); max-width: 480px; margin: 0 auto 44px; line-height: 1.65; }
.v-cta-form { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; max-width: 520px; margin: 0 auto 18px; }
.v-cta-input { flex: 1; min-width: 220px; padding: 13px 18px; background: rgba(255,255,255,0.07); border: 0.5px solid rgba(255,255,255,0.15); border-radius: 8px; font-size: 14px; color: var(--white); outline: none; font-family: inherit; transition: border-color 0.2s; }
.v-cta-input:focus { border-color: rgba(45,212,170,0.5); }
.v-cta-input::placeholder { color: rgba(255,255,255,0.3); }
.v-cta-note { font-size: 12px; color: rgba(255,255,255,0.25); }

/* FOOTER */
.v-footer { background: #070f0e; padding: 36px 5%; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; border-top: 0.5px solid rgba(255,255,255,0.05); }
.v-footer-logo { font-size: 14px; font-weight: 700; color: var(--teal); letter-spacing: 0.08em; text-transform: uppercase; }
.v-footer-sub { font-size: 11px; color: rgba(255,255,255,0.2); margin-top: 2px; }
.v-footer-right { font-size: 12px; color: rgba(255,255,255,0.2); }

/* CLOSED BETA BANNER */
.v-beta-banner { background: rgba(239,159,39,0.12); border-bottom: 1px solid rgba(239,159,39,0.3); padding: 10px 5%; text-align: center; font-size: 12px; color: #EF9F27; font-weight: 500; letter-spacing: 0.03em; }
.v-beta-banner strong { font-weight: 700; }

@media (max-width: 768px) {
  .v-mockup-body { grid-template-columns: 1fr; }
  .v-mockup-sidebar { display: none; }
  .v-problem-grid, .v-segments-grid { grid-template-columns: 1fr; }
  .v-solution-layout, .v-origin-layout { grid-template-columns: 1fr; gap: 40px; }
  .v-pricing-grid { grid-template-columns: 1fr; max-width: 400px; }
  .v-nav-links { display: none; }
  .v-feature-showcase { display: none; }
}
`;

const FEATURES = [
  {
    header: 'Lead intake — web-to-lead',
    html: `
      <div style="background:rgba(45,212,170,0.06);border:0.5px solid rgba(45,212,170,0.2);border-radius:8px;padding:14px;margin-bottom:12px;">
        <div style="font-size:10px;color:rgba(255,255,255,0.4);margin-bottom:8px;letter-spacing:0.06em;text-transform:uppercase;">Embed on any page</div>
        <div style="font-family:monospace;font-size:10px;color:#a8f0de;line-height:1.7;">&lt;script<br>&nbsp;&nbsp;src="app.vestiga.io/embed/lead-form.js"<br>&nbsp;&nbsp;data-org-id="your-org-001"<br>&gt;&lt;/script&gt;</div>
      </div>
      <div style="display:flex;flex-direction:column;gap:7px;">
        <div style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:rgba(255,255,255,0.04);border-radius:6px;border:0.5px solid rgba(255,255,255,0.07);">
          <div style="width:6px;height:6px;border-radius:50%;background:#2dd4aa;flex-shrink:0;"></div>
          <span style="font-size:11px;color:rgba(255,255,255,0.7);">Reed, Thomas H. — submitted via web form</span>
          <span style="margin-left:auto;font-size:10px;padding:1px 7px;background:rgba(45,212,170,0.12);color:#2dd4aa;border-radius:8px;font-weight:600;">New</span>
        </div>
        <div style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:rgba(255,255,255,0.04);border-radius:6px;border:0.5px solid rgba(255,255,255,0.07);">
          <div style="width:6px;height:6px;border-radius:50%;background:#EF9F27;flex-shrink:0;"></div>
          <span style="font-size:11px;color:rgba(255,255,255,0.7);">Carter, Sam L. — possible duplicate detected</span>
          <span style="margin-left:auto;font-size:10px;padding:1px 7px;background:rgba(239,159,39,0.12);color:#EF9F27;border-radius:8px;font-weight:600;">Dup 91%</span>
        </div>
        <div style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:rgba(255,255,255,0.04);border-radius:6px;border:0.5px solid rgba(255,255,255,0.07);">
          <div style="width:6px;height:6px;border-radius:50%;background:#6366F1;flex-shrink:0;"></div>
          <span style="font-size:11px;color:rgba(255,255,255,0.7);">Franklin, Ida R. — in review</span>
          <span style="margin-left:auto;font-size:10px;padding:1px 7px;background:rgba(99,102,241,0.12);color:#6366F1;border-radius:8px;font-weight:600;">Review</span>
        </div>
      </div>
    `,
  },
  {
    header: 'AI-powered record matching',
    html: `
      <div style="margin-bottom:12px;">
        <div style="font-size:10px;color:rgba(255,255,255,0.35);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:8px;">Candidate matches — Williams, James T.</div>
        <div style="display:flex;flex-direction:column;gap:6px;">
          <div class="v-fs-match-row" style="border-color:rgba(45,212,170,0.35)">
            <div class="v-fs-match-score">92</div>
            <div><div class="v-fs-match-name">Williams, James T. · Age 34</div><div class="v-fs-match-src">Ancestry.com · ED 41</div></div>
            <div style="display:flex;gap:4px;margin-left:auto"><button style="font-size:10px;padding:2px 8px;border:0.5px solid rgba(45,212,170,0.4);border-radius:4px;background:transparent;color:#2dd4aa;cursor:pointer;font-family:inherit;">Accept</button></div>
          </div>
          <div class="v-fs-match-row" style="opacity:0.75">
            <div class="v-fs-match-score" style="color:var(--amber)">71</div>
            <div><div class="v-fs-match-name">Williams, J.T. · Age ~35</div><div class="v-fs-match-src">FamilySearch · ED 41</div></div>
            <div style="display:flex;gap:4px;margin-left:auto"><button style="font-size:10px;padding:2px 8px;border:0.5px solid rgba(45,212,170,0.4);border-radius:4px;background:transparent;color:#2dd4aa;cursor:pointer;font-family:inherit;">Accept</button></div>
          </div>
          <div class="v-fs-match-row" style="opacity:0.55">
            <div class="v-fs-match-score" style="color:var(--red)">48</div>
            <div><div class="v-fs-match-name">Williamson, James · Age 36</div><div class="v-fs-match-src">State death cert. · ED 39</div></div>
            <div style="display:flex;gap:4px;margin-left:auto"><button style="font-size:10px;padding:2px 8px;border:0.5px solid rgba(226,75,74,0.4);border-radius:4px;background:transparent;color:#E24B4A;cursor:pointer;font-family:inherit;">Reject</button></div>
          </div>
        </div>
      </div>
      <div style="background:rgba(255,255,255,0.04);border-radius:6px;padding:10px 12px;font-size:11px;color:rgba(255,255,255,0.4);">Score factors: name variant · age proximity · enumeration district · occupation · household composition</div>
    `,
  },
  {
    header: 'Research timeline — Carter, Samuel L.',
    html: `
      <div style="display:flex;flex-direction:column;gap:0;">
        ${[
          { color: '#2dd4aa', text: 'Record imported from 1920 Census dataset', time: 'Mar 10, 2024 · System' },
          { color: '#2dd4aa', text: 'AI pipeline: 2 match candidates, confidence 84', time: 'Mar 13, 2024 · System' },
          { color: '#6366F1', text: 'State death certificate #TX-1924-00441 pulled — strong match on name and age', time: 'Mar 16, 2024 · M. Burdex' },
          { color: '#EF9F27', text: 'Status updated: Unresolved → Partial lead', time: 'Mar 16, 2024 · M. Burdex' },
        ].map(item => `
          <div style="display:flex;gap:10px;padding:9px 0;border-bottom:0.5px solid rgba(255,255,255,0.05);">
            <div style="width:22px;height:22px;border-radius:50%;background:${item.color}18;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;">
              <div style="width:6px;height:6px;border-radius:50%;background:${item.color};"></div>
            </div>
            <div>
              <div style="font-size:11px;color:rgba(255,255,255,0.7);line-height:1.4;">${item.text}</div>
              <div style="font-size:9px;color:rgba(255,255,255,0.25);margin-top:2px;">${item.time}</div>
            </div>
          </div>
        `).join('')}
      </div>
    `,
  },
  {
    header: 'Households & Places',
    html: `
      <div style="display:flex;flex-direction:column;gap:8px;margin-bottom:12px;">
        ${[
          { name: 'Anderson Household', addr: '418 N. Greenwood Ave · ED 41', status: 'Unresolved', color: '#E24B4A' },
          { name: 'Jackson Household', addr: '812 E. Easton St · ED 41', status: 'All confirmed', color: '#2dd4aa' },
          { name: 'Carter Household', addr: '204 N. Detroit Ave · ED 38', status: 'Partial', color: '#EF9F27' },
        ].map(h => `
          <div style="display:flex;align-items:center;gap:10px;padding:9px 12px;background:rgba(255,255,255,0.04);border:0.5px solid rgba(255,255,255,0.07);border-radius:7px;">
            <div style="width:28px;height:28px;background:#0d1f1d;border-radius:5px;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0;">🏠</div>
            <div style="flex:1;">
              <div style="font-size:11px;font-weight:600;color:rgba(255,255,255,0.85);">${h.name}</div>
              <div style="font-size:10px;color:rgba(255,255,255,0.3);">${h.addr}</div>
            </div>
            <div style="font-size:10px;font-weight:600;padding:2px 7px;background:${h.color}18;color:${h.color};border-radius:8px;">${h.status}</div>
          </div>
        `).join('')}
      </div>
      <div style="background:rgba(45,212,170,0.06);border:0.5px solid rgba(45,212,170,0.2);border-radius:6px;padding:10px 12px;">
        <div style="font-size:10px;color:var(--teal);font-weight:600;margin-bottom:6px;">📍 Vernon AME Church — 311 N. Greenwood Ave</div>
        <div style="font-size:10px;color:rgba(255,255,255,0.4);">87 persons associated · 3 sources attached · Religious</div>
      </div>
    `,
  },
  {
    header: 'Descendant portal',
    html: `
      <div style="background:rgba(45,212,170,0.06);border:0.5px solid rgba(45,212,170,0.2);border-radius:8px;padding:16px;margin-bottom:14px;text-align:center;">
        <div style="font-size:11px;color:rgba(255,255,255,0.5);margin-bottom:10px;">Family submission tracking</div>
        <div style="font-size:14px;font-weight:600;color:var(--white);margin-bottom:4px;">Reed, Thomas H.</div>
        <div style="font-size:11px;color:rgba(255,255,255,0.4);margin-bottom:14px;">Submitted May 28, 2024 by T. Reed</div>
        <div style="display:flex;justify-content:center;gap:6px;align-items:center;margin-bottom:8px;">
          <div style="width:28px;height:4px;background:var(--teal);border-radius:2px;"></div>
          <div style="width:28px;height:4px;background:var(--teal);border-radius:2px;"></div>
          <div style="width:28px;height:4px;background:rgba(255,255,255,0.15);border-radius:2px;"></div>
          <div style="width:28px;height:4px;background:rgba(255,255,255,0.15);border-radius:2px;"></div>
        </div>
        <div style="font-size:10px;color:rgba(255,255,255,0.35);">Received → In review → Matched → Confirmed</div>
      </div>
      <div style="font-size:11px;color:rgba(255,255,255,0.5);line-height:1.6;padding:0 4px;">No account required. Families receive a private tracking link and are notified the moment their ancestor is confirmed in the system.</div>
    `,
  },
  {
    header: 'Partner collaboration',
    html: `
      <div style="margin-bottom:12px;">
        <div style="font-size:10px;color:rgba(255,255,255,0.35);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:8px;">Partner organizations</div>
        ${[
          { name: 'Greenwood Cultural Center', role: 'Full access', color: '#2dd4aa' },
          { name: 'Mass Graves Investigation', role: 'Read + match queue', color: '#6366F1' },
          { name: '1921 Massacre Commission', role: 'Read only', color: '#EF9F27' },
        ].map(p => `
          <div style="display:flex;align-items:center;gap:10px;padding:9px 12px;background:rgba(255,255,255,0.04);border:0.5px solid rgba(255,255,255,0.07);border-radius:7px;margin-bottom:7px;">
            <div style="width:8px;height:8px;border-radius:50%;background:${p.color};flex-shrink:0;"></div>
            <div style="font-size:11px;font-weight:500;color:rgba(255,255,255,0.8);flex:1;">${p.name}</div>
            <div style="font-size:10px;color:rgba(255,255,255,0.35);">${p.role}</div>
          </div>
        `).join('')}
      </div>
      <div style="background:rgba(255,255,255,0.04);border-radius:6px;padding:10px 12px;font-size:11px;color:rgba(255,255,255,0.4);line-height:1.6;">Each partner org sees only what you choose to share. Individual record access, aggregate data, or full collaboration — all configurable.</div>
    `,
  },
];

export default function VestigaLandingPage() {
  const [activeFeature, setActiveFeature] = useState(0);
  const [ctaEmail, setCtaEmail] = useState('');
  const [ctaNote, setCtaNote] = useState('No commitment required. We\'ll reach out within 48 hours.');
  const [ctaNoteColor, setCtaNoteColor] = useState('rgba(255,255,255,0.25)');

  useEffect(() => {
    const styleEl = document.createElement('style');
    styleEl.id = 'vestiga-styles';
    styleEl.textContent = VESTIGA_CSS;
    document.head.appendChild(styleEl);

    const fontLink = document.createElement('link');
    fontLink.rel = 'preconnect';
    fontLink.href = 'https://fonts.googleapis.com';
    document.head.appendChild(fontLink);

    const fontLink2 = document.createElement('link');
    fontLink2.rel = 'stylesheet';
    fontLink2.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,700;1,400&display=swap';
    document.head.appendChild(fontLink2);

    return () => {
      document.getElementById('vestiga-styles')?.remove();
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCtaNote(`✓ Got it — we'll reach out to ${ctaEmail} within 48 hours.`);
    setCtaNoteColor('#2dd4aa');
    setCtaEmail('');
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="vestiga-page" style={{ paddingTop: 0 }}>
      {/* Closed beta banner */}
      <div className="v-beta-banner">
        <strong>Closed Beta</strong> — Vestiga is currently invite-only. Early access applications are open.
      </div>

      {/* NAV */}
      <nav className="v-nav">
        <div className="v-nav-logo">Vestiga</div>
        <ul className="v-nav-links">
          <li><a href="#v-problem" onClick={e => { e.preventDefault(); scrollTo('v-problem'); }}>The problem</a></li>
          <li><a href="#v-solution" onClick={e => { e.preventDefault(); scrollTo('v-solution'); }}>Features</a></li>
          <li><a href="#v-segments" onClick={e => { e.preventDefault(); scrollTo('v-segments'); }}>Who it's for</a></li>
          <li><a href="#v-origin" onClick={e => { e.preventDefault(); scrollTo('v-origin'); }}>Our story</a></li>
          <li><a href="#v-pricing" onClick={e => { e.preventDefault(); scrollTo('v-pricing'); }}>Pricing</a></li>
        </ul>
        <a href="#v-cta" className="v-nav-cta" onClick={e => { e.preventDefault(); scrollTo('v-cta'); }}>Request early access</a>
      </nav>

      {/* HERO */}
      <section id="v-hero">
        <div className="v-hero-glow" />
        <div className="v-hero-eyebrow">
          <span className="v-hero-eyebrow-dot" />
          Now in early access
        </div>
        <h1 className="v-hero-headline">
          The platform built to<br /><em>find who history missed.</em>
        </h1>
        <p className="v-hero-sub">
          Vestiga is the first purpose-built investigative CRM for historical missing persons research — connecting archivists, commissions, and descendants around the records that matter most.
        </p>
        <div className="v-hero-actions">
          <button className="v-btn-primary" onClick={() => scrollTo('v-cta')}>Request early access</button>
          <button className="v-btn-ghost" onClick={() => scrollTo('v-solution')}>See how it works</button>
        </div>

        {/* Dashboard mockup */}
        <div className="v-hero-mockup">
          <div className="v-mockup-bar">
            <div className="v-mockup-dots">
              <div className="v-mockup-dot" />
              <div className="v-mockup-dot" />
              <div className="v-mockup-dot" />
            </div>
            <div className="v-mockup-url">app.vestiga.io/dashboard</div>
          </div>
          <div className="v-mockup-body">
            <div className="v-mockup-sidebar">
              <div className="v-ms-logo">Vestiga</div>
              <div className="v-ms-section">Workspace</div>
              <div className="v-ms-item active"><span className="v-ms-item-dot" style={{ background: '#2dd4aa' }} /> Dashboard</div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Leads <span className="v-ms-badge alert">23</span></div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Persons <span className="v-ms-badge teal">1,739</span></div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Match Queue <span className="v-ms-badge alert">47</span></div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Households</div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Places</div>
              <div className="v-ms-section">Research</div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> AI Connections</div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Data Sources</div>
              <div className="v-ms-item"><span className="v-ms-item-dot" style={{ background: '#ffffff33' }} /> Reports</div>
            </div>
            <div className="v-mockup-main">
              <div className="v-m-topbar">
                <div className="v-m-title">Dashboard</div>
                <div className="v-m-search">Search records...</div>
              </div>
              <div className="v-m-stats">
                <div className="v-m-stat">
                  <div className="v-m-stat-label">Active pool</div>
                  <div className="v-m-stat-val">1,739</div>
                  <div className="v-m-stat-sub">878 households</div>
                </div>
                <div className="v-m-stat">
                  <div className="v-m-stat-label">Match queue</div>
                  <div className="v-m-stat-val accent">47</div>
                  <div className="v-m-stat-sub">pending review</div>
                </div>
                <div className="v-m-stat">
                  <div className="v-m-stat-label">Confirmed</div>
                  <div className="v-m-stat-val">363</div>
                  <div className="v-m-stat-sub">removed from pool</div>
                </div>
                <div className="v-m-stat">
                  <div className="v-m-stat-label">No archival trace</div>
                  <div className="v-m-stat-val">735</div>
                  <div className="v-m-stat-sub">highest priority</div>
                </div>
              </div>
              <div className="v-m-panels">
                <div className="v-m-panel">
                  <div className="v-m-panel-hdr"><div className="v-m-panel-dot" /> Match queue</div>
                  <div className="v-m-queue-item">
                    <div className="v-m-score strong">92</div>
                    <div><div className="v-m-qname">Williams, James T.</div><div className="v-m-qmeta">Age 34 · ED 41 · Ancestry match</div></div>
                  </div>
                  <div className="v-m-queue-item">
                    <div className="v-m-score probable">74</div>
                    <div><div className="v-m-qname">Johnson, Mary E.</div><div className="v-m-qmeta">Age 28 · ED 38 · FamilySearch</div></div>
                  </div>
                  <div className="v-m-queue-item">
                    <div className="v-m-score weak">53</div>
                    <div><div className="v-m-qname">Davis, Lula M.</div><div className="v-m-qmeta">Age 22 · ED 39 · Church roll</div></div>
                  </div>
                </div>
                <div className="v-m-panel">
                  <div className="v-m-panel-hdr"><div className="v-m-panel-dot" style={{ background: '#EF9F27' }} /> Recent activity</div>
                  <div className="v-m-act-item">
                    <div className="v-m-act-dot" style={{ background: '#2dd4aa' }} />
                    <div><div className="v-m-act-text">Survivor confirmed — Thomas Reed, age 38</div><div className="v-m-act-time">2 hours ago · M. Burdex</div></div>
                  </div>
                  <div className="v-m-act-item">
                    <div className="v-m-act-dot" style={{ background: '#EF9F27' }} />
                    <div><div className="v-m-act-text">Partial lead flagged — Anderson household</div><div className="v-m-act-time">4 hours ago · B. McPherson</div></div>
                  </div>
                  <div className="v-m-act-item">
                    <div className="v-m-act-dot" style={{ background: '#2dd4aa' }} />
                    <div><div className="v-m-act-text">47 new candidates from AI pipeline</div><div className="v-m-act-time">6 hours ago · System</div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM */}
      <section id="v-problem" className="v-section">
        <div className="v-section-eyebrow">The problem</div>
        <h2 className="v-section-headline">Every research team is building the same thing from scratch.</h2>
        <p className="v-section-sub">Massacre commissions. Genealogical societies. University archives. Reparations legal teams. Every one of them is managing thousands of historical person records in spreadsheets — with no automation, no collaboration, and no audit trail.</p>
        <div className="v-problem-grid">
          {[
            { num: '01', title: 'Spreadsheets can\'t scale', body: 'Teams managing thousands of records in Excel with no shared access, version control, or audit trail. One researcher leaves, the knowledge goes with them.' },
            { num: '02', title: 'Manual archive lookups', body: 'Researchers spend hours on Ancestry.com and FamilySearch — one record at a time, no automation, results going nowhere useful. The same lookups happen twice across teams.' },
            { num: '03', title: 'No collaboration layer', body: 'Multiple organizations researching the same event with no shared infrastructure. Duplicate effort, conflicting findings, and no way to build on each other\'s work.' },
            { num: '04', title: 'Families are shut out', body: 'Descendants submit names through Google Forms or email and hear nothing back. No tracking. No status. No moment when a family finds out their ancestor has been found.' },
            { num: '05', title: 'No evidentiary standard', body: 'Reparations and legal cases demand defensible evidence trails. A spreadsheet doesn\'t produce a case file. The research is real — the documentation isn\'t.' },
            { num: '06', title: 'No tool built for this', body: 'Ancestry is consumer genealogy. Salesforce wasn\'t built for archival records. Case management software doesn\'t understand probabilistic matching. Nothing fits.' },
          ].map(card => (
            <div key={card.num} className="v-problem-card">
              <div className="v-problem-num">{card.num}</div>
              <div className="v-problem-title">{card.title}</div>
              <div className="v-problem-body">{card.body}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SOLUTION */}
      <section id="v-solution" className="v-section">
        <div className="v-section-eyebrow">The solution</div>
        <h2 className="v-section-headline">One platform for the entire investigative workflow.</h2>
        <p className="v-section-sub">From first lead to confirmed record — Vestiga is built around how this research actually happens, not how generic software thinks it should.</p>
        <div className="v-solution-layout">
          <div className="v-feature-list">
            {[
              { icon: '📥', title: 'Lead intake & web-to-lead', desc: 'Embed a form on any existing page. Submissions land directly in a managed queue with automatic duplicate detection — no manual data entry.' },
              { icon: '🔍', title: 'AI-powered record matching', desc: 'Probabilistic matching across census, genealogy, and archival sources. Confidence-scored candidates reviewed by your researchers — not blindly accepted.' },
              { icon: '📋', title: 'Research timeline & audit trail', desc: 'Every search attempt, source citation, and status change is logged per person and per household. The research survives when researchers move on.' },
              { icon: '🏘️', title: 'Households & Places', desc: 'Work a family unit together. Associate persons with churches, schools, detention sites, and residential addresses. Research anchored to real geography.' },
              { icon: '👪', title: 'Descendant portal', desc: 'Families submit names and receive a tracking link. No account required. When their ancestor is confirmed, they find out — automatically.' },
              { icon: '🤝', title: 'Partner collaboration', desc: 'Share data between organizations with granular access controls. Five Tulsa research teams on one platform. No more duplicate work across silos.' },
            ].map((f, i) => (
              <div key={i} className={`v-feature-item${activeFeature === i ? ' active' : ''}`} onClick={() => setActiveFeature(i)}>
                <div className="v-feature-icon">{f.icon}</div>
                <div className="v-feature-text">
                  <div className="v-feature-title">{f.title}</div>
                  <div className="v-feature-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="v-feature-showcase">
            <div className="v-fs-header">{FEATURES[activeFeature].header}</div>
            <div className="v-fs-body" dangerouslySetInnerHTML={{ __html: FEATURES[activeFeature].html }} />
          </div>
        </div>
      </section>

      {/* SEGMENTS */}
      <section id="v-segments" className="v-section">
        <div className="v-section-eyebrow">Who it's for</div>
        <h2 className="v-section-headline">Built for any organization where the work is finding people history erased.</h2>
        <p className="v-section-sub">One platform. Every org configures it for their specific research context — different field names, different sources, same rigorous workflow.</p>
        <div className="v-segments-grid">
          {[
            { icon: '⚖️', title: 'Massacre & Atrocity Commissions', body: 'Tulsa 1921. Rosewood. Elaine. Wilmington 1898. Research teams building the evidentiary foundation for recognition and reparations.', count: '50+ active US commissions' },
            { icon: '🌿', title: 'Indigenous Communities', body: 'Land records research, family displacement tracking, and tribal enrollment documentation across 500+ federally recognized nations.', count: '500+ tribes with active research needs' },
            { icon: '🎓', title: 'University Archive Departments', body: 'Structured research programs across historical records, oral histories, and document collections — built for collaboration and citation.', count: '400+ active programs' },
            { icon: '📜', title: 'Genealogical Societies', body: 'Managing member submissions, coordinating research across volunteers, and maintaining defensible records for communities seeking their history.', count: '7,000+ societies in the US' },
            { icon: '🏛️', title: 'Reparations Legal Teams', body: 'Building case files that meet evidentiary standards. Every source cited, every decision logged, every finding traceable to its origin document.', count: 'Multi-state legislative activity' },
            { icon: '🌍', title: 'International Research Orgs', body: 'Holocaust research institutes, post-conflict truth commissions, refugee displacement projects — the workflow is universal.', count: 'Global expansion phase' },
          ].map((s, i) => (
            <div key={i} className="v-segment-card">
              <div className="v-segment-icon">{s.icon}</div>
              <div className="v-segment-title">{s.title}</div>
              <div className="v-segment-body">{s.body}</div>
              <div className="v-segment-count">{s.count}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ORIGIN */}
      <section id="v-origin" className="v-section">
        <div className="v-origin-layout">
          <div>
            <div className="v-section-eyebrow">Our story</div>
            <h2 className="v-section-headline">Built from the research, not from the outside.</h2>
            <blockquote className="v-origin-quote">
              "We didn't build software and look for a market. We built the methodology, found the market, and then productized what already works."
            </blockquote>
            <p className="v-origin-body">
              Vestiga grew out of two years of on-the-ground historical research in Tulsa, Oklahoma — developing the Census Disruption Methodology (CDM) to identify individuals who disappeared from the historical record following the 1921 Tulsa Race Massacre.
            </p>
            <p className="v-origin-body">
              Working directly with the Greenwood Cultural Center, the 1921 Race Massacre Commission, and the mass graves investigation team, the research exposed a gap no existing tool could fill. Vestiga is the tool built to fill it.
            </p>
            <p className="v-origin-body">
              The platform is built by researchers, for researchers — with deep respect for the communities whose ancestors it is designed to find.
            </p>
            <div className="v-origin-stat-row">
              <div>
                <div className="v-origin-stat-val">2+</div>
                <div className="v-origin-stat-label">Years of active research</div>
              </div>
              <div>
                <div className="v-origin-stat-val">1,739</div>
                <div className="v-origin-stat-label">Records in active CDM pool</div>
              </div>
              <div>
                <div className="v-origin-stat-val">363</div>
                <div className="v-origin-stat-label">Survivors confirmed</div>
              </div>
            </div>
          </div>
          <div className="v-origin-visual">
            <div className="v-ov-title">Census Disruption Methodology — Tulsa 1921</div>
            {[
              { num: '01', label: 'Census baseline — 1920 individuals enumerated in Greenwood', val: '1,739' },
              { num: '02', label: 'Post-event archival cross-reference completed', val: '1,004' },
              { num: '03', label: 'Confirmed survivors removed from pool', val: '363' },
              { num: '04', label: 'Partial leads awaiting secondary confirmation', val: '247' },
              { num: '05', label: 'No archival trace — highest research priority', val: '735', highlight: true },
            ].map(row => (
              <div key={row.num} className="v-ov-row">
                <div className="v-ov-num">{row.num}</div>
                <div className="v-ov-label" style={row.highlight ? { color: 'var(--teal)', fontWeight: 600 } : {}}>{row.label}</div>
                <div className="v-ov-val" style={row.highlight ? { color: 'var(--red)' } : {}}>{row.val}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="v-pricing" className="v-section">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <div className="v-section-eyebrow" style={{ justifyContent: 'center', display: 'flex' }}>Pricing</div>
          <h2 className="v-section-headline" style={{ margin: '14px auto', textAlign: 'center' }}>Simple, institutional-friendly pricing.</h2>
          <p className="v-section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>License-based SaaS. Scale your seats as your team grows. No per-record fees.</p>
        </div>
        <div className="v-pricing-grid">
          {/* Starter */}
          <div className="v-pricing-card">
            <div className="v-pricing-header light">
              <div className="v-pricing-name">Starter</div>
              <div className="v-pricing-price">$299</div>
              <div className="v-pricing-period">per month</div>
              <div className="v-pricing-desc">Small research orgs and community groups getting started.</div>
            </div>
            <ul className="v-pricing-features">
              {['Up to 3 Investigator seats', '5,000 person records', 'Lead intake & match queue', 'Households & Places', 'Basic reporting', 'Email support'].map(f => (
                <li key={f}><span className="v-pricing-check">✓</span> {f}</li>
              ))}
            </ul>
            <div className="v-pricing-footer">
              <button className="v-pricing-cta outline" onClick={() => scrollTo('v-cta')}>Get started</button>
            </div>
          </div>

          {/* Professional */}
          <div className="v-pricing-card featured">
            <div className="v-pricing-badge">Most popular</div>
            <div className="v-pricing-header">
              <div className="v-pricing-name">Professional</div>
              <div className="v-pricing-price">$799</div>
              <div className="v-pricing-period">per month</div>
              <div className="v-pricing-desc">Active commissions, university depts, and research orgs.</div>
            </div>
            <ul className="v-pricing-features">
              {['Up to 10 Investigator seats', 'Unlimited person records', 'AI matching pipeline', 'API access & integrations', 'Partner collaboration', 'Advanced analytics'].map(f => (
                <li key={f}><span className="v-pricing-check">✓</span> {f}</li>
              ))}
            </ul>
            <div className="v-pricing-footer">
              <button className="v-pricing-cta teal" onClick={() => scrollTo('v-cta')}>Get started</button>
            </div>
          </div>

          {/* Enterprise */}
          <div className="v-pricing-card">
            <div className="v-pricing-header light">
              <div className="v-pricing-name">Enterprise</div>
              <div className="v-pricing-price">$2,500<span style={{ fontSize: 18 }}>+</span></div>
              <div className="v-pricing-period">per month</div>
              <div className="v-pricing-desc">Governments, large institutes, and legal firms.</div>
            </div>
            <ul className="v-pricing-features">
              {['Unlimited seats', 'White-label deployment', 'Custom integrations', 'Data agreements & compliance', 'Dedicated support & SLA', 'On-premise option'].map(f => (
                <li key={f}><span className="v-pricing-check">✓</span> {f}</li>
              ))}
            </ul>
            <div className="v-pricing-footer">
              <button className="v-pricing-cta dark" onClick={() => scrollTo('v-cta')}>Contact us</button>
            </div>
          </div>
        </div>
        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--gray2)', marginTop: 24 }}>
          Viewer seats are always free — families and read-only collaborators never count against your license.
        </p>
      </section>

      {/* CTA */}
      <section id="v-cta" className="v-section" style={{ background: 'var(--dark)', textAlign: 'center', padding: '100px 5%', position: 'relative', overflow: 'hidden' }}>
        <div className="v-cta-glow" />
        <div className="v-section-eyebrow" style={{ textAlign: 'center', display: 'block' }}>Early access</div>
        <h2 className="v-section-headline">Be among the first organizations on the platform.</h2>
        <p className="v-cta-sub">We're onboarding a small cohort of research organizations in 2025. Early access includes white-glove onboarding and a direct line to the product team.</p>
        <form className="v-cta-form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="v-cta-input"
            placeholder="your@organization.org"
            value={ctaEmail}
            onChange={e => setCtaEmail(e.target.value)}
            required
          />
          <button type="submit" className="v-btn-primary">Request access</button>
        </form>
        <p className="v-cta-note" style={{ color: ctaNoteColor }}>{ctaNote}</p>
      </section>

      {/* FOOTER */}
      <footer className="v-footer">
        <div>
          <div className="v-footer-logo">Vestiga</div>
          <div className="v-footer-sub">Historical Records Platform · Built by the Center for the Uncounted</div>
        </div>
        <div className="v-footer-right">© 2025 Vestiga · All rights reserved</div>
      </footer>
    </div>
  );
}
